
















































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import FeedContent from '@/components/Feed/FeedContent.vue'

@Component({
  components: { FeedContent },
})
export default class FeedVote extends Vue {
  @Prop({ required: true }) a!: any
  get img () {
    return this.a.voteable.linkPreview && this.a.voteable.linkPreview.img
  }
  get title () {
    return this.a.voteable.linkPreview && this.a.voteable.linkPreview.title
  }
}

